import React, { createContext, useContext, useState } from "react";

const PageMetadataContext = createContext();

export const usePageMetadata = () => {
  const context = useContext(PageMetadataContext);
  if (!context) {
    throw new Error(
      "usePageMetadata must be used within a PageMetadataProvider"
    );
  }
  return context;
};

export const PageMetadataProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState("");
  const [pageSubtitle, setPageSubtitle] = useState("");

  const value = {
    pageTitle,
    pageSubtitle,
    setPageTitle,
    setPageSubtitle,
    clearMetadata: () => {
      setPageTitle("");
      setPageSubtitle("");
    },
  };

  return (
    <PageMetadataContext.Provider value={value}>
      {children}
    </PageMetadataContext.Provider>
  );
};
